export default "/images/vendor/flag-icon-css/flags/4x3/ir.svg?95a4d32e20e010f63ae710f22213399c";